import {
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   ElementRef,
   EventEmitter,
   Input,
   Output,
   ViewChild,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Actions, ofType } from '@ngrx/effects';
import { AddBlockedPhoneNumberData } from '../models/add-blocked-phone-number-data';
import * as addBlockedPhoneNumber from '../state/add-blocked-phone-number.actions';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-blocked-phone-number-view',
    styleUrls: ['./add-blocked-phone-number-view.component.scss'],
    templateUrl: './add-blocked-phone-number-view.component.html',
    standalone: false
})
export class AddBlockedPhoneNumberViewComponent {
   @ViewChild('phoneNumber') phoneNumber: ElementRef;

   @Input() callState: CallState;

   @Output() formSubmitted = new EventEmitter<AddBlockedPhoneNumberData>();

   @Output() saveAndAddAnother = new EventEmitter<AddBlockedPhoneNumberData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: UntypedFormGroup;

   constructor(private actions$: Actions, private changeDetectorRef: ChangeDetectorRef) {}

   ngOnInit() {
      this.actions$.pipe(ofType(addBlockedPhoneNumber.createBlockedPhoneNumberAndAddAnotherSuccess)).subscribe(() => {
         this.clearBlockedPhoneNumberFields();
         this.form.markAsPristine();
         this.form.markAsUntouched();
         this.phoneNumber.nativeElement.focus();
      });
   }

   clearBlockedPhoneNumberFields() {
      this.form.get('phoneNumber')?.setValue('');
      this.form.get('comment')?.setValue('');
      this.changeDetectorRef.markForCheck();
   }

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }

   onCreateAndAddAnother() {
      if (this.form.valid) {
         this.saveAndAddAnother.emit();
      } else {
         this.form.markAllAsTouched();
      }
   }
}
